import React from 'react';
import Sidebar from "../../components/sidebar/Sidebar";
import "../../styles/sidebar/sidebar.css";
import Header from "../../components/header/Header";
import RecordedDataComponent from '../../components/recordedData/RecordedDataComponent';

const ScannerRecordedData = () => {
  return (
        <>
        <div className="recorded-data-container">
                <Sidebar role="scanner-assistant"/>
            <div className="main-content">
                <Header/>
                <RecordedDataComponent role="scanner-operator" title="ARCHIVE SCANNED DATA"/>
            </div>
        </div>
        </>
      )
}

export default ScannerRecordedData